<div [ishServerHtml]="htmlContent"></div>
